module.exports = __webpack_public_path__ + "img/icon_project04.c0df2ff4.png";